import React, { InputHTMLAttributes } from 'react';
import { Option } from '~/types/products';
import DefaultFilters from './components/DefaultFilters';
import MobileFilters from './components/MobileFilters';

interface Props {
  productFilters: {
    addPhoneState: boolean;
    options: Option[];
    setOptions: (options: Option[]) => void;
    sweetener: Option;
    voiceAvailable: boolean;
    handleAddHomePhone: (event: InputHTMLAttributes<HTMLInputElement>) => void;
    setSweetener: (selected: Option) => void;
  };
  filterType?: string;
  options?: {
    phone: string;
    rewards: string;
  };
  setOpenModal: () => void;
  comparisonToolEnabled: boolean;
}

const Filters: React.FC<Props> = ({ productFilters, filterType, options, setOpenModal, comparisonToolEnabled }) => {
  const isCheckbox = filterType === 'checkbox';
  const Filters = isCheckbox ? MobileFilters : DefaultFilters;
  return (
    <Filters
      productFilters={productFilters}
      options={options}
      data-testid="product-filters"
      setOpenModal={setOpenModal}
      comparisonToolEnabled={comparisonToolEnabled}
    />
  );
};

Filters.displayName = 'Filters';

export default Filters;
